import { WebComponentBaseClass } from '/third_party/web-component-base-class/dist/web-component-base-class.js';

const webComponentName = 'vicowa-styles';
window.customElements.define(webComponentName, class extends WebComponentBaseClass {
	static get is() { return webComponentName; }
	constructor() { super(); }

	static get template() {
		return `
 		<style>
	:host {
		}
	</style>
		<slot name="style-content"></slot>
		`;
	}
});

